const Updated = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path d="M4.175 6.763a3.494 3.494 0 0 1 6.464-.978l1.743-.98A5.494 5.494 0 0 0 2.22 6.343L1 6.083 2.726 8.75l2.668-1.726-1.22-.261Zm8.56.005-2.706 1.667 1.214.288a3.494 3.494 0 0 1-6.484.835l-1.765.941a5.494 5.494 0 0 0 10.194-1.314l1.214.289-1.667-2.706Z" />
    </svg>
);

export default Updated;
